<template>
  <GModal class="modal--edit-photo normalize-gutter">
    <div slot="header">
      <div class="show-desktop">
        <button type="button" class="close" aria-label="Close">
          <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
        </button>
      </div>

      <div class="show-mobile">
        <button type="button" class="close" aria-label="Close">
          <img src="/assets/img/icons/back.svg" alt="SOCO" @click.prevent="closeModal" />
        </button>

        <h2 class="modal-heading modal-heading__header">EDIT CAPTION</h2>
      </div>
    </div>
    <div slot="body">
      <div class="bj-uploader">
        <div class="bj-uploader__multiple">
          <div class="bj-uploader-frame">
            <div class="bj-uploader-frame__content">
              <div class="bj-uploader-frame__thumb">
                <img :src="file" class="bj-uploader-frame__img" alt="SOCO" />
                <!-- <a href="" @click.prevent="cropImage(productPhoto.file, $store.state.writeReview.productShotKeyActive)" class="bj-uploader-frame__icon-crop"></a> -->
              </div>

              <div class="bj-uploader-frame__caption">
                <label class="bj-uploader-frame__heading">Photo Caption</label>
                <span class="bj-uploader-frame__counter-caption">{{ existingCaption.length }} / 100</span>

                <textarea
                  v-model="existingCaption"
                  class="form-control bj-uploader-frame__textare"
                  placeholder="Write your caption here..."
                  maxlength="100"
                ></textarea>

                <div class="text-right group-button">
                  <button type="button" class="btn btn-dark btn-upload" @click.prevent="saveChanges">SAVE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-edit-photo',
  data() {
    return {
      tempCaption: '',
      existingCaption: '',
    };
  },
  computed: {
    caption() {
      return this.$store.state.writeReview.editPhoto.caption;
    },
    file() {
      return this.$store.state.writeReview.editPhoto.file;
    },
    captionPhoto: {
      get() {
        return this.caption;
      },
      set(value) {
        this.tempCaption = value;
      },
    },
  },
  mounted() {
    this.existingCaption = this.caption;
  },
  methods: {
    closeModal() {
      this.$store.dispatch('setModalEditPhoto', { newValModal: false });
    },
    saveChanges() {
      if (this.existingCaption !== '') {
        this.$store.commit('updateProductShotCaption', {
          productShotKey: this.$store.state.writeReview.productShotKeyActive,
          newCaption: this.existingCaption,
        });
      }
      this.$store.dispatch('setModalEditPhoto', { newValModal: false });
    },
    cropImage(fileImageBase64, productShotKey) {
      this.$store.dispatch('setImageForCrop', {
        file: fileImageBase64,
        productShotKey: productShotKey,
      });
      this.$store.dispatch('setModalCropPhoto', true);
    },
  },
};
</script>
